import { postAction } from './method'

export const queryByPageDownload = data => postAction('/arap/fts/fileUploadTemp/queryPageFree', { data }, { hasUserInfo: true }) //分页查询
